<template>
  <div id='bd-kb-category'>
    <span>分类</span>
    <div>
      <el-button size="mini" @click="create">创建</el-button>
      <el-button v-if="editVisitor" size="mini" @click="preview">预览</el-button>
      <el-button v-if="editVisitor" size="mini" @click="update">编辑</el-button>
      <el-button v-if="editVisitor" size="mini" @click="doDelete">删除</el-button>
    </div>
    <div style="height: calc(100% - 60px); overflow-y: auto;">
      <li v-for="category in allCategories"
        class="list-item"
        :class="{ ' active': category.id === currentCategory.id }"
        @click.exact="handleNodeClick(category)"
        :key="category.id">
        <div class="list-right">
          <div class="top">
            <span class="nickname">{{ category.name }}</span>
          </div>
          <!-- <hr/> -->
        </div>
      </li>
      <!-- <el-pagination
          :page-size="pageSize"
          :pager-count="5"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
          :page-count="articles.totalPages"
          :total="articles.totalElements"
          :hide-on-single-page="true"
          layout="prev, pager, next"
        >
        </el-pagination> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import * as https from '@/apis/http'
// import bus from '@/util/eventbus'
const constants = require('@/util/constants')

export default {
  name: 'bd-kb-category',
  data () {
    return {
      currentPage: 1,
      pageSize: 10,
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf'
      }
    }
  },
  computed: {
    ...mapGetters("knowledgebase", ['categories', 'articles', 'currentCategory', 'knowledgebase']),
    allCategories() {
      let allcategories = [
        {
          id: 0,
          cid: '',
          name: '全部',
          leaf: true
        }
      ]
      for (let i = 0; i < this.categories.length; i++) {
        const element = this.categories[i]
        allcategories.push(element)
      }
      return allcategories
    },
    editVisitor() {
      return this.currentCategory.id !== 0
    }
  },
  methods: {
    ...mapActions("knowledgebase", ['queryKnowledgebase', 'createCategory', 'updateCategory',
      'deleteCategory', 'getCategoriesSupport', 'getArticlesSupport', 'updateCurrentCategory']),
    //
    handleNodeClick(category) {
      // console.log('handleNodeClick: ',category);
      this.updateCurrentCategory(category)
      // 
      let payload2 = { categoryId: category.id, page: 0, size: this.pageSize }
      this.getArticlesSupport(payload2)
    },
    allArticles() {
      // 
      let payload2 = { categoryId: 0, page: 0, size: this.pageSize }
      this.getArticlesSupport(payload2)
    },
    create() {
      this.$prompt('请输入分类名称', '创建分类', {
        confirmButtonText: this.$t("ok"),
        cancelButtonText: this.$t("cancel"),
      })
        .then(({ value }) => {
          // console.log(value)
          if (value !== undefined && value !== null && value.length > 0) {
            let payload = {
              parent_id: 0,
              name: value,
              type: constants.CATEGORY_TYPE_SUPPORT,
            };
            this.createCategory(payload);
          }
        })
        .catch(() => {
          // 取消
        });
    },
    update() {
      //
      this.$prompt('请输入分类名称', '编辑分类', {
        confirmButtonText: this.$t("ok"),
        cancelButtonText: this.$t("cancel"),
        inputValue: this.currentCategory.name,
      })
      .then(({ value }) => {
        // console.log(value)
        if (value !== undefined && value !== null && value.length > 0) {
          let payload = {
            category_id: this.currentCategory.id,
            name: value,
          };
          this.updateCategory(payload);
        }
      })
      .catch(() => {
        // 取消
      });
    },
    doDelete() {
      console.log('currentCategory: ', this.currentCategory)
      this.$confirm("确定要删除: " + this.currentCategory.name + " ?", this.$t("tip"), {
        confirmButtonText: this.$t("ok"),
        cancelButtonText: this.$t("cancel"),
        type: "warning",
      })
      .then(() => {
        this.deleteCategory(this.currentCategory.id)
      })
      .catch(() => {});
    },
    preview() {
      if (this.currentCategory.cid === '') {
        this.$message.info('请先选择类别')
        return
      }
      if (constants.IS_PRODUCTION) {
        window.open('https://' + this.knowledgebase.subDomain + '.docs.bytedesk.com/category_' + this.currentCategory.cid + '.html')
      } else {
        window.open('http://127.0.0.1:8887/category_' + this.currentCategory.cid + '.html')
      }
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      // 加载
      let payload = { page: this.currentPage - 1, size: this.pageSize }
    this.getCategoriesSupport(payload)
    },
  },
  created () {
    //
    let payload = { page: 0, size: this.pageSize }
    this.getCategoriesSupport(payload)
    //
    this.allArticles()
    //
    this.queryKnowledgebase()
  },
  mounted() {
    
  },
  filters: {
    // 将日期过滤为 hour:minutes
    time (value) {
      if (typeof value === 'string') {
        return moment(value).format('MM-DD HH:mm:ss')
      } else {
        return value
      }
    }
  }
}
</script>

<style scoped>
#bd-kb-category {
  width: 100%;
  height: 100%;
  float: left;
}
#bd-kb-category {
  width: 100%;
  height: 100%;
  float: left;
}
#bd-kb-category .list-item {
  padding: 5px 5px 5px 5px;
  margin-bottom: 0px;
  border-bottom: 1px solid beige;
  /* height: 50px; */
  height: auto;
}
#bd-kb-category .list-item:hover {
  background-color: rgb(220, 220, 220);
}
.active {
  background-color: darkkhaki;
}
#bd-kb-category .list-item .avatar {
  border-radius: 2px;
  margin-right: 2px;
}
#bd-kb-category li {
  list-style: none;
}
#bd-kb-category .list-right {
  margin-left: 5px;
}
#bd-kb-category .list-right .top {
  margin-top: 2px;
  text-align: left;
}
#bd-kb-category .list-right-ticket {
  margin-left: 5px;
}
#bd-kb-category .list-right-ticket .top {
  margin-top: 2px;
  text-align: left;
}
#bd-kb-category span.nickname {
  display: inline-block;
  vertical-align: top;
  font-size: 14px;
  width: calc(100% - 100px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
